import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

export default function ProductPageHeader({ slug }) {
    return (
        <div className="product-page-header">
            <Breadcrumb
                items={[
                    {
                        title: (
                            <Link data-external-check-exempt to="/">
                                Cotizaciones
                            </Link>
                        ),
                    },
                    {
                        title: slug,
                    },
                ]}
            />
        </div>
    );
}
